import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { palette } from 'theme';

const LogoLink = styled(Link)`
  margin-right: auto;
`;

const LogoWrapper = styled.span`
  svg {
    width: 120px;
    height: 20px;
    path,
    g,
    polygon {
      fill: ${props =>
        props.color === 'default' ? 'white' : palette.grey[900]};
    }
    @media (min-width: 400px) {
      width: 180px;
      height: 20px;
    }
  }
`;

const LogoContent = ({ color }) => (
  <LogoWrapper color={color}>
    <svg viewBox="0 0 180 18">
      <defs />
      <path d="M71.6 14.1l-.1-.1-4.2-5.5c-2-2.6-4-5.2-5.9-7.8-.1-.1-.1-.1-.2-.1h-2.1v17h2.1V4.1l.1.1 5.8 7.6c1.4 1.9 2.9 3.8 4.3 5.7.1.1.2.2.3.2h2V.7h-2.1v13.4zM180 8.5c0-1-.2-2.1-.5-3.1-.6-2.1-1.9-3.6-4-4.4-1-.4-2-.6-3.1-.6-1.4-.1-2.8 0-4.1.4-2.1.6-3.7 1.8-4.5 3.9-.4 1-.6 2.1-.7 3.1-.1 1.5 0 2.9.3 4.3.3 1.2.8 2.3 1.7 3.2.9.9 2 1.6 3.3 1.9 1.2.3 2.5.4 3.7.4.9 0 1.9-.2 2.8-.4 2.1-.5 3.8-2.1 4.5-4.1.4-1.3.7-2.7.6-4.1v-.5zm-2.9 3.9c-.7 1.9-2.1 3-4 3.3-1.2.2-2.5.2-3.7-.1-1.9-.5-3.1-1.8-3.7-3.7-.3-1.2-.4-2.5-.3-3.8 0-.9.2-1.8.6-2.6.5-1.5 1.8-2.6 3.3-3 1.5-.4 3-.4 4.5 0 1.8.5 2.9 1.7 3.5 3.4.3.9.4 1.9.4 2.9 0 1.2-.2 2.4-.6 3.6zM112.3.5V8h-10.2V.5h-2.2v17h2.2V9.8h10.2v7.7h2.2V.5zM125.2 9.8h8.4V8h-8.4V2.3h8.9V.5H123v17h11.2v-1.8h-9zM29 8.7c-.9-.5-1.8-.7-2.7-.7h-3.1c-.4 0-.7 0-1.1-.1-.8-.1-1.4-.5-1.8-1.2-.2-.4-.3-.8-.3-1.3 0-1.1.4-2.1 1.4-2.6.8-.4 1.7-.6 2.5-.6 1.9-.1 3.7.1 5.5.7l.7.2v-2H30C28.9.8 27.7.6 26.6.5 25.4.4 24.2.4 23 .5c-.9.1-1.8.3-2.6.6-1.2.5-2.1 1.5-2.4 2.7-.3 1-.3 2.1 0 3.1.3 1.1 1 2 2 2.4.7.3 1.5.5 2.4.5h3.1c.4 0 .8 0 1.1.1.8.1 1.5.5 1.9 1.3.3.6.4 1.2.3 1.8 0 .4-.2.9-.4 1.3-.4.6-1.1 1.1-1.9 1.3-.8.2-1.7.3-2.6.2-1.3 0-2.7-.2-4-.5-.4-.1-.9-.2-1.3-.4v2h.1c.9.2 1.8.4 2.8.5 1.1.1 2.2.2 3.3.2 1.1 0 2.2-.2 3.2-.5 1.3-.5 2.3-1.3 2.7-2.6.3-1 .4-2 .2-3-.2-1.3-.9-2.3-1.9-2.8zM155.4 10v-.2h-2.2v5.8h-.1c-1.5.4-3.1.4-4.7 0-1.9-.4-3.3-1.6-4-3.4-.3-.8-.5-1.7-.5-2.5-.1-1.1 0-2.1.2-3.2.3-1.5 1.3-2.8 2.7-3.5.9-.5 2-.7 3-.8 1.7-.1 3.4.1 5 .6l.5.2v-.2-1.4c0-.3.1-.3-.3-.4-1.6-.5-3.3-.7-5.1-.6-1.1 0-2.1.2-3.2.5-2.4.7-4 2.2-4.7 4.6-.3 1.1-.5 2.3-.4 3.5 0 1 .1 1.9.3 2.9.3 1.3 1 2.5 1.9 3.5 1 .9 2.1 1.5 3.4 1.8 1.3.3 2.6.5 3.9.4 1.3 0 2.7-.3 4-.7.1 0 .2-.1.2-.3.1-2.2.1-4.4.1-6.6zM52 .5h-2.4c-.1 0-.2.1-.2.1L45 8.4l-.5.9-.1-.2c-1.6-2.8-3.1-5.6-4.7-8.5 0-.1-.1-.2-.2-.1H37.2c0 .1.1.1.1.1 2 3.6 4 7.2 6 10.7.1.1.1.2.1.3v5.7h2.2v-.2-5.5c0-.1 0-.3.1-.4C47.8 7.6 49.9 4.1 52 .5c0 .1.1.1 0 0 .1 0 .1 0 0 0zM80.4 2.3h5.3v15.2h2.2V2.3h5.3V.5H80.4zM0 16.5l1.1 1.1 9.2-9.2-1.1-1.1zM-.029 11.886L6.84 5.037 7.97 6.17 1.1 13.02zM1.1 8.4l4.6-4.6-1.1-1.1L0 7.3zM3.4 1.5L2.3.4 0 2.7l1.1 1.1z" />
    </svg>
  </LogoWrapper>
);

const Logo = ({ color, link = true }) =>
  link ? (
    <LogoLink to="/">
      <LogoContent color={color} />
    </LogoLink>
  ) : (
    <LogoContent color={color} />
  );

export default Logo;
